export default __webpack_public_path__ + "static/Banner1-a695d17230c886f3442f0006676974cf.png";